import React from 'react'
import styled from 'styled-components'
import R from 'ramda'
import { fromNullable } from 'data.maybe'
import { pure } from 'recompose'

import { scaleLinear, scaleBand, scaleOrdinal } from 'd3-scale'
import { max } from 'd3-array'
import { schemeCategory10 } from 'analytics'

const Title = styled.div`
  font-size: 1.3em;
  font-weight: bold;
  color: #666;
  padding-bottom: 10px;
  padding-top: 10px;
  text-align: center;
  background-color: #dcdcdc;
  margin-left: -5px;
  margin-right: -5px;
  margin-top: -5px;
  margin-bottom: 5px;
  border-radius: 5px 5px 0px 0px;
`
const AltTitle = styled(Title)`
  background-color: #666;
  color: white;
`

const GoalBadge = ({
  display,
  actual,
  forecast,
  expected,
  score,
  width = 440,
  height = 220,
  colorScheme = schemeCategory10,
  alt = false,
}) => {
  const NormContainer = styled.div`
    /*border: solid red 1px;*/
    display: inline-block;
    flex: 0 0 ${width}px
    padding: 5px 5px 5px 5px;
    background-color: #eee;
    border-radius: 5px;
    margin: 8px;
  `
  const AltContainer = styled(NormContainer)`
    background-color: #444;
  `

  const Container = alt ? AltContainer : NormContainer

  const Content = styled.div`
    display: flex;
    align-items: center;
  `
  const scoreMargin = 10
  const scoreWidth = 140
  const svgHeight = height - 100
  const svgWidth = width - scoreWidth - scoreMargin

  const Score = styled.div`
    color: #666;
    width: ${scoreWidth}px;
    height: ${svgHeight}px;
    display: flex;
    align-items: center;
    font-size: 2.3em;
    font-weight: bold;
    text-align: center;
    justify-content: center;
    background-color: #ddd;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
  `

  const KpiType = styled.text`
    alignment-baseline: middle;
    fill: white;
    font-size: 1.3em;
    font-weight: bold;
    opacity: 0.8;
  `
  const KpiValue = styled.text`
    alignment-baseline: middle;
    text-anchor: end;
    font-size: 1.3em;
    /*
    fill:black;
    fill-opacity:1;
    stroke:white;
    stroke-width:.5px;
    stroke-linecap:butt;
    stroke-linejoin:miter;
    stroke-opacity:.5;
    */
  `

  const colorScale = scaleOrdinal(colorScheme)

  const cap = word =>
    fromNullable(word)
      .map(w => w.substr(0, 1))
      .map(w => w.toUpperCase())
      .getOrElse('')

  const createData = R.compose(
    R.map(([label, value]) => ({ label, value })),
    R.toPairs
  )

  const data = createData({
    actual,
    forecast,
    expected,
  })

  const kpiScale = scaleBand()
    .rangeRound([0, svgHeight])
    .paddingInner(0.2)
    // .padding(0.1)
    .domain(data.map(d => d.label))
  const maxVal = max(data, d => d.value)
  const valScale = scaleLinear()
    .rangeRound([0, svgWidth])
    .domain([0, maxVal])

  const Bar = styled.rect`
    fill-opacity: 0.75;
  `
  const toCap = str => str.charAt(0).toUpperCase() + str.slice(1)

  return (
    <Container>
      {alt ? <AltTitle>{display}</AltTitle> : <Title> {display} </Title>}
      <Content>
        <svg width={svgWidth + 5} height={svgHeight}>
          {data.map(({ label, value }) => (
            <g key={label} transform={`translate(5,${kpiScale(label)})`}>
              <Bar x={0} y={0} height={kpiScale.bandwidth()} width={valScale(maxVal)} fill="#ccc" />
              <Bar
                x={0}
                y={0}
                height={kpiScale.bandwidth()}
                width={valScale(value)}
                fill={colorScale(label)}
              >
                <title>{`${toCap(label)}:${value}`}</title>
              </Bar>
              <KpiType x={5} y={kpiScale.bandwidth() / 2 + 2}>
                {cap(label)}
              </KpiType>
              <KpiValue x={valScale(maxVal) - 5} y={kpiScale.bandwidth() / 2 + 2}>
                {fromNullable(value)
                  .map(v => v.toFixed(2))
                  .getOrElse(score)}
              </KpiValue>
            </g>
          ))}
        </svg>
        <Score title={`Score:${score}%`}>
          {fromNullable(score)
            .map(Math.round)
            .getOrElse(score)}
          %
        </Score>
      </Content>
    </Container>
  )
}

export default pure(GoalBadge)
